import React from 'react'
import Collection from '../common/collection'

function CollectionM({ props }) {
  return (
    <Collection
      src={[
        'https://volverse-negro-daniel.s3.amazonaws.com/images/12.+ni%C3%B1oabeja61.jpg',
      ]}
      alt="Niño abeja"
    />
  )
}


export default CollectionM
